import { Dialog } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const CardProvidedDialog = (props: any) => {
  const { open, onClose } = props;
  const handleEmailButtonClick = () => {
    window.location.href = "mailto:support@planetwise.io";
  };
  return (
    <Dialog open={open}>
      <div className="px-8 py-4 m-8 rounded-xl">
        <div className="flex justify-between items-center w-full">
          <div className={`pw-header-text`}>
            Card details have been captured
          </div>
          <div className="cursor-pointer">
            <CloseIcon
              className="pw-color-close-attchments"
              onClick={onClose}
            />
          </div>
        </div>
        <div className="mt-8">
          <div className="text-sm">
            <div className="">
              <span>Thank you for providing the payment details.</span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="text-sm">
            <div className="font-bold">
              <span>
                * Please note that it may take a few minutes for payment
                information to appear in our system. Please do not submit the
                payment details again.
              </span>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <div className="text-sm">
            <div className="">
              <span>For further queries, get in touch with us at </span>
              <span className="inline-flex">
                <div
                  className="text-blue-500 cursor-pointer"
                  onClick={handleEmailButtonClick}
                >
                  support@planetwise.io
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default CardProvidedDialog;
